import React from 'react';
import {
  DataGridButton,
  IColumnType,
  IDataType,
  SisDataGridColumns,
} from '../../../components/table';
import { STORAGE_KEYS } from '../../../utils/localStorageKeys';

export const Columns = (
  isReadOnly,
  currency,
  translate,
  handleEdit,
  handleRemove,
  transFormName,
  history,
  backRoute,
  // na záložce Tasku je sloupec zbytečný - všechny řádky by odkazovaly na stejný task
  hideTaskColumn,
): SisDataGridColumns => [
  {
    dataType: IDataType.date,
    dataField: 'accountingDate',
    caption: 'Accounting date',
    cssClass: 'dg-align-right',
    width: '10%',
  },
  ...(hideTaskColumn
    ? []
    : [
        {
          dataType: IDataType.string,
          dataField: 'taskCustomId',
          caption: 'Task id',
          cssClass: 'dg-align-left',
          width: '10%',
          cellRender: (cellData) => {
            return (
              <span
                className="context-link"
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() =>
                  history.push({
                    pathname: `/tasks/edit/${cellData.data.taskId}`,
                    state: { backRoute: backRoute },
                  })
                }
                // state změny spouští devexpress datagrid context menu, proto bez hooku
                onMouseEnter={() => {
                  window.localStorage.setItem(
                    STORAGE_KEYS.CONTEXT_STATE,
                    JSON.stringify({
                      path: `/tasks/edit/${cellData.data.taskId}`,
                      backRoute: backRoute,
                    }),
                  );
                }}
              >
                {cellData.data[cellData.column.dataField]}
              </span>
            );
          },
        },
      ]),
  {
    dataType: IDataType.string,
    dataField: 'typeName',
    caption: 'Cost type',
    cssClass: 'dg-align-left',
    width: '13%',
  },
  {
    dataType: IDataType.string,
    dataField: 'supplier',
    caption: 'Supplier',
    cssClass: 'dg-align-left',
    width: '17%',
  },
  {
    dataType: IDataType.string,
    dataField: 'description',
    caption: 'Description',
    cssClass: 'dg-align-left',
    width: '25%',
  },
  {
    dataType: IDataType.number,
    dataField: 'amount',
    caption: 'Amount',
    cssClass: 'dg-align-right',
    format: { type: 'fixedPoint', precision: 2 },
    // měna je společná pro celou aplikaci (Config), do záznamu se neukládá
    customizeText: (cellInfo) =>
      currency ? `${cellInfo.valueText} ${currency}` : cellInfo.valueText,
    // do Excelu exportovat jen číslo, bez měny z customizeText
    exportRawValue: true,
    // do Excelu exportovat caption včetně měny (v gridu je měna u hodnoty, ne v caption)
    exportCaption: currency
      ? `${translate!('Amount', transFormName)} ${currency}`
      : translate!('Amount', transFormName),
    width: '10%',
  },
  {
    dataType: IDataType.string,
    dataField: 'reference',
    caption: 'Reference',
    cssClass: 'dg-align-left',
    width: '10%',
  },
  {
    dataType: IDataType.number,
    dataField: 'attachmentCount',
    caption: 'Attachments',
    cssClass: 'dg-align-right',
    width: '4%',
  },
  {
    dataType: IDataType.string,
    dataField: 'createdByName',
    caption: 'Created by',
    cssClass: 'dg-align-left',
    width: '10%',
    visible: false,
  },
  {
    dataType: IDataType.dateTime,
    dataField: 'created',
    caption: 'Created',
    cssClass: 'dg-align-right',
    width: '10%',
    visible: false,
  },
  {
    dataType: IDataType.string,
    dataField: 'updatedByName',
    caption: 'Updated by',
    cssClass: 'dg-align-left',
    width: '10%',
    visible: false,
  },
  {
    dataType: IDataType.dateTime,
    dataField: 'updated',
    caption: 'Updated',
    cssClass: 'dg-align-right',
    width: '10%',
    visible: false,
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => {
      if (isReadOnly) return <></>;
      return ButtonCell(data, translate, handleEdit, handleRemove);
    },
    width: '7%',
  },
];

const ButtonCell = (cellData, translate, handleEdit, handleRemove) => {
  return (
    <>
      <DataGridButton
        hint={translate!('Edit', '')}
        icon="edit"
        cellData={cellData}
        onClick={handleEdit}
      />
      <DataGridButton
        hint={translate!('Delete', '')}
        icon="trash"
        cellData={cellData}
        onClick={handleRemove}
      />
    </>
  );
};
